import { useHistory } from 'react-router-dom';

import { Container, Menu, StyledCurrencyIcon } from './_sidebar';

import repfy_logo_white from 'assets/repfy_logo_white.svg';

import tools from 'assets/icons/tools.svg';
import profile from 'assets/icons/profile.svg';
import history_icon from 'assets/icons/history.svg';
import support_service from 'assets/icons/support_service.svg';

export const Sidebar: React.FC = () => {
  const history = useHistory();

  return (
      <Container>
        <Menu>
          <img
            className="menu__logo"
            src={repfy_logo_white}
            alt="RepFy o melhor lugar para prestadores de serviço"
            onClick={() => history.push('/')}
          />

          {/* <div className="menu__item" onClick={() => history.push('/servicos')}>
            <img className="menu__item__icon" src={tools} alt="Serviços" />

            <span>Serviços</span>
          </div> */}

          <div className="menu__item" onClick={() => history.push('/servicos')}>
            <StyledCurrencyIcon />

            <span>Meus preços</span>
          </div>

          <div className="menu__item" onClick={() => history.push('/perfil')}>
            <img className="menu__item__icon" src={profile} alt="Perfil" />

            <span>Perfil</span>
          </div>

          <div className="menu__item" onClick={() => history.push('/agenda')}>
            <img
              className="menu__item__icon"
              src={history_icon}
              alt="Agenda"
            />

            <span>Agenda</span>
          </div>

          <div className="menu__item" onClick={() => history.push('/suporte')}>
            <img
              className="menu__item__icon"
              src={support_service}
              alt="Suporte"
            />

            <span>Suporte</span>
          </div>
        </Menu>
      </Container>
  );
};
